module.exports = __webpack_public_path__ + "img/IMG-20200315-WA0049.5134b672.jpg";